import React, { useEffect, useState } from 'react'
import { useSelector } from "src/stateManagement/redux";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import moment from "moment";
import { tableStyles } from 'src/shared/util/tableStyles';

export const SteamModule = () => {


  const { locationSteamEventHistory } = useSelector((state) => state.location);

  const [waterDataTable, setWaterDataTable] = useState<any[]>([])

  useEffect(() => {
    const data = locationSteamEventHistory.map((item) => {
      return {
        ...item,
      }
    })
    setWaterDataTable(data)
  }, [locationSteamEventHistory])
  
  const paginationModel = { page: 0, pageSize: 10 };

  const dataColumns: GridColDef[] = [
    {
      field: "startOfInyectionCycleDate",
      headerName: "Fecha Inicio Ciclo",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const formattedDate = params.value
          ? moment(params.value).format("DD-MM-YY")
          : "";
        return (
          <Typography
            variant="body2"
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
            }}
          >
            {formattedDate}
          </Typography>
        );
      },
    },
    {
      field: "endOfInyectionCycleDate",
      headerName: "Fecha Fin Ciclo",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const formattedDate = params.value
          ? moment(params.value).format("DD-MM-YY")
          : "";
        return (
          <Typography
            variant="body2"
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
            }}
          >
            {formattedDate}
          </Typography>
        );
      },
    },
    {
      field: "inyectionPlant",
      headerName: "Planta de Inyección",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "cycleNumber",
      headerName: "Número de Ciclo",
      flex: 0.8,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "type",
      headerName: "Tipo",
      flex: 0.8,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "acumulatedInyection",
      headerName: "Inyección Acumulada",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Typography
            variant="body2"
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
            }}
          >
            {params.value ? params.value.toLocaleString() : ""}
          </Typography>
        );
      },
    },
    {
      field: "averageInyection",
      headerName: "Inyección Promedio",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Typography
            variant="body2"
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
            }}
          >
            {params.value ? params.value.toLocaleString() : ""}
          </Typography>
        );
      },
    },
  ]

  return (
    <Box className="table-container">
    <DataGrid
        rows={waterDataTable}
        columns={dataColumns}
        initialState={{
            pagination: { paginationModel }
        }}
        pageSizeOptions={[10, 20, 50, 100]}
        checkboxSelection={false}
        sx={{
           ...tableStyles
        }}
        getRowId={(row) => row.id}
    />
</Box>
  )
}
